<main id="main-content" class="h-screen flex flex-col pl-8 py-4 pr-4 transition-all duration-0">
    <div class="w-full flex flex-col p-2 items-center gap-2">
        <div class="w-full flex flex-row items-center justify-between">
            <div class="w-full flex gap-2 items-center justify-start">
                <h1 class="oswald-font text-3xl uppercase">
                    Schedule
                </h1>
                <div data-popover-target="popover-right" data-popover-placement="right" type="button">
                    <lucide-icon [name]="icons.CircleHelp" [size]=24 class="text-red-500"></lucide-icon>
                </div>
                <div data-popover id="popover-right" role="tooltip" class="absolute z-30 invisible inline-block w-[600px] text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-md shadow-xs opacity-0">
                    <div class="px-3 py-2">
                        <p>
                            Logs can be created in either the log table or the Calendar view.
                        </p>
                        <p>
                            To create a log in the <strong>Logs</strong> table, click on 
                            <span class="inline-flex px-2 h-8 rounded-md bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 text-white oswald-font flex items-center justify-center gap-2">
                                <lucide-icon [img]="icons.Plus"></lucide-icon>
                                <p class="hidden xl:block">Add New Event</p>
                            </span>. A pop-up will appear allowing you to fill out important information related to the log. All sections are required except for a file upload. When completed, click on 
                            <span class="inline-flex px-3.5 py-1 flex items-center justify-center text-white oswald-font bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 rounded-md">
                                Save
                            </span>
                        </p>
                        <p>
                            To create a log in the <strong>Calendar</strong> view, simply click on the day that the log was or will be completed. A pop-up will appear above allowing you to fill out important information related to the log. Follow the same instructions as above.
                        </p>
                        <p>
                            To edit or delete a log in the <strong>Logs</strong> table, simply click 
                            <span class="inline-flex w-8 h-8 rounded border-2 border-nside-gray-200 text-nside-gray-200 flex items-center justify-center">
                                <lucide-icon [img]="icons.FileText" size="20"></lucide-icon>
                            </span>. To edit the log, click on 
                            <span class="inline-flex w-8 h-8 flex items-center justify-center p-2 rounded-md border border-nside-orange-100 bg-gradient-to-b from-nside-orange-100 to-nside-orange-200 oswald-font text-white">
                                <lucide-icon [name]="icons.Pencil" [size]="20"></lucide-icon>
                            </span>. To delete an event, click on 
                            <span class="inline-flex w-8 h-8 flex items-center justify-center p-2 rounded-md border border-nside-gray-300 bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 oswald-font text-white whitespace-nowrap"
                            >
                                <lucide-icon [name]="icons.Trash2" [size]="20"></lucide-icon>
                            </span>. Once an event has been deleted, the event and any associated files cannot be retrieved again.
                        </p>
                    </div>
                    <div data-popper-arrow></div>
                </div>
            </div> 
            <eop-assistant
                [sectionId]="sectionTypeId"
            ></eop-assistant>
        </div>
    </div>
    
    <!-- MAIN CONTENT -->
    <div class="p-2 w-full flex flex-grow flex-row items-start gap-8 overflow-y-auto">
        <div class="w-full h-full flex gap-8 items-start justify-center">
            <div class="sm:w-1/2 xl:w-2/5 h-full p-6 bg-white rounded-md shadow-custom-2 ">
                <ng-container *ngIf="hydrated">
                  <full-calendar #fullcalendar [options]="calendarOptions"></full-calendar>
                </ng-container>
            </div>
            <div class="sm:w-1/2 xl:w-3/5 h-full overflow-y-auto p-6 bg-white rounded-md shadow-custom-2">
                <schedule-table 
                    class="w-full h-full"
                    [schedulesList]="scheduleTable"
                    (onOpenModal)="handleOpenModal($event.modalName, $event.selectedItem)"
                    (onSchoolYearChange)="handleSchoolYearChange($event)"
                ></schedule-table>
            </div>
        </div>
    </div>
    
    <introduction></introduction>

    <event-details 
        *ngIf="showEventDetails" 
        [eventDetails]="selectedEvent"
        (onClose)="handleCloseModal('event-details')"
        (onOpenModal)="handleOpenModal($event.modalName, $event.selectedItem, $event.itemType)"
    ></event-details>

    <new-event
        *ngIf="showCreateEvent"
        [selectedDate]="selectedDate"
        (onClose)="handleCloseModal('create-event')"
        (onSave)="handleSave($event, 'create-event')"
    ></new-event>

    <event-edit
        *ngIf="showEventEdit"
        [eventToEdit]="selectedEvent"
        (onClose)="handleCloseModal('edit-event')"
        (onSave)="handleSave($event, 'edit-event')"
    ></event-edit>

    <delete-confirmation
        *ngIf="showDeleteConfirmation"
        [text]="'this ' + deleteItemType"
        [itemToDelete]="selectedEvent"
        (onClose)="handleCloseModal('delete-confirmation')"
        (onDelete)="handleDelete($event)"
    ></delete-confirmation>

    <div *ngIf="loading">
        <spinner></spinner>
    </div>

    <popup-message 
        [type]="messageModal"
        [message]="popupMessage"
        (close)="resetMessageModal()"
    ></popup-message>

    <prv-next-buttons [totalPages]="(eopNavigationService.totalPages$ | async) || []" />
</main>